import debug from 'Helper/debugHelpers'
import { doLogout } from 'actions/authActions'
import { openModal } from 'actions/modalActions'
import { put } from 'redux-saga/effects'
import { apiCallbacks } from '../XtractAPI.jsx'
// finally a general callback for any other status type... this should never get
// called but if it does, print a debug statement letting us know what happened.
export function defaultCallback(response, action) {
  debug.log(
    'There was no callback to handle status:' + response.status,
    debug.logLevels.API,
    'error'
  )
  return null
}

const defaultCallbacks = {
  default: defaultCallback,
  503: function* (response, action) {
    debug.logObject(
      'An api request was made resulting in 404 not found',
      action,
      debug.logLevels.AUTH,
      'error'
    )
    yield put(doLogout())
  },
  ...apiCallbacks
}

export default defaultCallbacks
